import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { navigationData as product } from "../jsonFiles/navigationData";
import "./offCanvas.css";

export default function OffCanvas({
  mainwidth,
  setMainWidth,
  opaacity,
  setOpacity,
  canvasWidth,
  setCanvasWidth,
  hide,
  setHide,
  closeAllCollapses,
}) {
  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);


  // Filter product array and child items based on permissions
  const filteredProduct = product
    .map((item) => {
      if (item.id === "DashBoard") {
        return item; // Always include DashBoard
      }

      // Filter child items based on permissions
      const permittedChildren = item.Childs
        ? item.Childs.filter((child) => permissions.includes(child.id))
        : [];

      // Include parent if it has permitted children or its own ID is in permissions
      if (permittedChildren.length > 0 || permissions.includes(item.id)) {
        return {
          ...item,
          Childs: permittedChildren,
        };
      }

      return null;
    })
    .filter((item) => item !== null);

  // Function to toggle the sidebar width
  function settingWidth() {
    if (!mainwidth) {
      setMainWidth(true);
      setCanvasWidth("250px");
      setTimeout(() => {
        setOpacity("100%");
        setHide("block");
      }, 300);
    } else {
      setMainWidth(false);
      setCanvasWidth("74px");
      setOpacity("0%");
      setHide("none");
      closeAllCollapses(); // Close all collapses when collapsing the off-canvas menu
    }
  }

  // Function to handle dropdown toggle
  const handleDropdown = (id) => {
    const dropdownMenu = document.getElementById(id);
    if (dropdownMenu) {
      if (dropdownMenu.classList.contains("show")) {
        dropdownMenu.classList.remove("show");
      } else {
        dropdownMenu.classList.add("show");
      }
    }
  };

  return (
    <div>
      <div
        style={{ width: canvasWidth, left: "0", overflow: "visible" }}
        className="sideBar position-fixed"
      >
        {/* Floating Toggle Button - Kept outside scrollable content */}
        <button
          className="sidebar-toggle-btn p-0"
          onClick={() => settingWidth()}
          title={mainwidth ? "Collapse Menu" : "Expand Menu"}
        >
          <i className={mainwidth ? "bi bi-chevron-left" : "bi bi-chevron-right"}></i>
        </button>

        {/* Scrollable Content Container */}
        <div style={{
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          width: canvasWidth,
          display: 'flex',
          flexDirection: 'column'
        }} className="sidebar-scroll-container">
          {/* Company Logo Section */}
          <div className="logo-container">
            <img
              src="https://prosevo.com/assets/logoprosevo.png"
              alt="Prosevo Logo"
              className="logo-img"
            />
            <span className="logo-text" style={{ display: hide, opacity: opaacity }}>
              Prosevo
            </span>
          </div>

          <div
            className="accordion accordion-flush flex-column d-flex flex-grow-1"
            style={{ width: canvasWidth }}
            id="accordionFlushExample"
          >
            {/* Top Collapse/Expand Toggle Button - MOVED TO FLOATING POSITION */}
            {filteredProduct.map((item, index) => (
              <div className={`accordion-item w-100 ${!mainwidth ? 'hover-wrapper' : ''}`} key={item.id}>
                <div
                  className="button_Container"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle={item.Childs && item.Childs.length > 0 && mainwidth ? "collapse" : ""}
                  data-bs-target={item.Childs && item.Childs.length > 0 && mainwidth ? `#flush-collapse${item.id}` : ""}
                  aria-expanded="false"
                  aria-controls={`flush-collapse${item.id}`}
                  onClick={() => {
                    if (!mainwidth) settingWidth();
                  }}
                >
                  {item.link ? (
                    <Link
                      to={item.link}
                      className="w-100 text-decoration-none d-flex align-items-center h-100"
                      style={{ color: "inherit" }}
                    >
                      <div className="d-flex align-items-center h-100 w-100">
                        <i
                          className={`icons ${item.icon} d-flex justify-content-center`}
                          onClick={(e) => {
                            if (!mainwidth) {
                              e.preventDefault();
                              settingWidth();
                            }
                          }}
                        ></i>
                        <p
                          className="icon-text mb-0 flex-grow-1 text-nowrap d-flex align-items-center h-100"
                          style={{ display: hide, opacity: opaacity }}
                        >
                          {item.header}
                        </p>
                      </div>
                    </Link>
                  ) : (
                    <div className="d-flex align-items-center h-100 w-100">
                      <i
                        className={`icons ${item.icon} d-flex justify-content-center`}
                      ></i>
                      <div
                        className="d-flex w-100 justify-content-between align-items-center"
                        style={{ display: hide, opacity: opaacity }}
                      >
                        <p className="icon-text mb-0 text-nowrap flex-grow-1">
                          {item.header}
                        </p>
                        {item.Childs && item.Childs.length > 0 && (
                          <i className="lni lni-chevron-down" style={{ marginRight: '16px', fontSize: '12px', transition: 'transform 0.3s' }}></i>
                        )}
                      </div>
                    </div>
                  )}

                  {!mainwidth && item.Childs && item.Childs.length > 0 && (
                    <div className="dropdown dropend" style={{ zIndex: 30 }}>
                      <ul
                        className="dropdown-menu p-0"
                        style={{ zIndex: 1050 }}
                        id={`dropdownMenu_${item.id}`}
                      >
                        {item.Childs.map((child) => (
                          <li key={child.id} style={{ height: "35px", zIndex: 30 }}>
                            <Link
                              to={child.link}
                              className="dropdown-item"
                              style={{ zIndex: "30" }}
                            >
                              {child.Name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {item.Childs && item.Childs.length > 0 && (
                  <div
                    id={`flush-collapse${item.id}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      {item.Childs.map((child) => (
                        <button key={child.id} className="btn w-100 text-start rounded-0">
                          <Link style={{ overflow: 'hidden' }} className="w-100 h-100" to={child.link}>
                            {child.Name}
                          </Link>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}